import React, { useState } from "react";
import PropTypes from "prop-types";

const CollapsibleListWrapper = ({
  listItems,
  collapseBtnTitle = "View less",
  expandBtnTitle = "View more",
  visibleItems,
  listItemCustomIcon = <></>,
  listItemStyle = "not-italic lato-regular-latin text-sm text-generic-text dark:gvi-light-gray-text w-full ",
  btnStyle = "underline underline-offset-2 py-4 text-generic-text dark:text-white text-sm",
  wrapperContainerStyle = "",
  listStyle = "grid grid-cols-1 sm:grid-cols-2"
}) => {
  const [readMore, setReadMore] = useState(false);
  const [showLimit, setShowLimit] = useState(parseInt(visibleItems));
  const linkName = readMore ? collapseBtnTitle : expandBtnTitle;

  return (
    <div className={wrapperContainerStyle}>
      <ul className={listStyle}>
        {listItems?.slice(0, showLimit)?.map((listItem, idx) => (
          <li key={`skill-key-${idx}`} className={`${listItemStyle}`}>
            {listItemCustomIcon} {listItem.title}
          </li>
        ))}
      </ul>
      {listItems?.length > visibleItems && (
        <button
          className={btnStyle}
          onClick={() => {
            setReadMore(!readMore);
            setShowLimit(!readMore ? listItems?.length : visibleItems);
          }}
        >
          {linkName}
        </button>
      )}
    </div>
  );
};

CollapsibleListWrapper.propTypes = {
  visibleItems: PropTypes.number,
  listItems: PropTypes.array,
  listStyle: PropTypes.string,
  listItemStyle: PropTypes.string,
  btnStyle: PropTypes.string,
  wrapperContainerStyle: PropTypes.string
};

export default CollapsibleListWrapper;
